import { Component } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {NgForOf, NgIf, NgOptimizedImage} from "@angular/common";
import {CompanyImagePipe} from "../../../pipes/company-image.pipe";
import {Company} from "../../../models/company.model";

@Component({
  selector: 'app-company-modal',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    NgOptimizedImage,
    CompanyImagePipe
  ],
  templateUrl: './company-modal.component.html',
  styleUrl: './company-modal.component.scss'
})
export class CompanyModalComponent {

  company!: Company;

  constructor(private modalRef: BsModalRef) {}

  closeModal(): void {
    this.modalRef.hide();
  }
}
